import { render, staticRenderFns } from "./BidangPengurus.vue?vue&type=template&id=567902f1"
import script from "./BidangPengurus.vue?vue&type=script&lang=js"
export * from "./BidangPengurus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports